




import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import SortIcon from "@/shared/components/SortIcon.vue";
import {
  ClaimsPageRequestSortableColumn,
  SortOrder
} from "@/shared/types";
import { useClaimStore } from "@/employee/store/claim";

@Component({
  components: { SortIcon }
})
export default class HsabImportedClaimColumnSortIcon extends Vue {
  claimStore = useClaimStore();

  @Prop({ required: true })
  talonClaimColumn: ClaimsPageRequestSortableColumn;

  get isSortedByColumn () {
    return this.claimStore.claimPageResultSet.sortByColumn === this.talonClaimColumn;
  }
  get sortOrder () {
    if (this.isSortedByColumn) {
      return this.claimStore.claimPageResultSet.sortOrder;
    }
    return SortOrder.None;
  }
}
